import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CriarFornecedorFormData } from "../schema/criar-fornecedor.schema";


const criar = async (data: CriarFornecedorFormData): Promise<void> => {
    try {
        await baseApiService.post('/supplier', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/supplier/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/supplier/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: CriarFornecedorFormData): Promise<void> => {
    try {
        await baseApiService.put(`/supplier/${id}`, data);
    }
    catch (err) {
        console.error("Erro ao editar fornecedor:", err);
        throw errosHandler(err);
    }
};

const findAll = async (
    query?: string,
    pagina = 0,
    limite = 10
): Promise<any> => {
    try {
        const page = pagina + 1;
        
        const url = query
            ? `/supplier?page=${page}&limit=${limite}&${query}`
            : `/supplier?page=${page}&limit=${limite}`;

        const response = await baseApiService.get(url);
        return response.data.data;

    } catch (error) {
        throw errosHandler(error);
    }
};


const select = async (): Promise<any> => {
    try {
        const response = await baseApiService.get('/supplier/select');
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const buscarFornecedores = async (termo: string): Promise<{ id: string; label: string }[]> => {
    try {
        if (!termo || termo.trim().length < 2) {
            return [];
        }

        const response = await baseApiService.get(
            `/supplier?campo_pesquisa=name&valor_pesquisa=${encodeURIComponent(termo)}&page=1&limit=20`
        );

        const items = response.data?.data?.items || [];
        return items.map((fornecedor: any) => ({
            id: fornecedor.id,
            label: fornecedor.name || fornecedor.corporateName || fornecedor.fullName || "",
        }));
    } catch (err) {
        console.error("Erro ao buscar fornecedores:", err);
        throw errosHandler(err);
    }
};

export const fornecedorService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    select,
    buscarFornecedores,
};

